import {Col, FormGroup, Input, Label, InputGroup} from "reactstrap";

const TokenInVaultInputs = ({password, handleInputChange, lgColSize}) => {

    const filterTokenInVaultDevices = () => {
        return (
            <>
                <Col lg={8} sm={6}>
                    <FormGroup>
                        <Label htmlFor="api_token">API Token</Label>
                        <span className="badge bg-danger"> Required </span>
                        <InputGroup>
                            <Input
                                required
                                type={'password'}
                                name="password"
                                value={password}
                                onChange={handleInputChange}/>
                        </InputGroup>
                    </FormGroup>
                </Col>
            </>
        )
    }

    return filterTokenInVaultDevices();
}

export default TokenInVaultInputs;